import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminWeekendBoostPage() { return <ModuleAdminPage title="週末耀旺加碼" code="weekend-boost" text="管理週末時間、3,000/5,000 門檻與每週限制。" />; }
